import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/role-detail";

export const pagingRoleDetail = (searchObject) => {
  var url = API_PATH + "/paging-role-detail";
  return axios.post(url, searchObject);
};

export const getRoleDetail = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRoleDetail = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRoleDetail = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRoleDetail = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const getAllRoleDetail = () => {
  var url = API_PATH + "/get-all-role-detail";
  return axios.get(url);
};
